import { render, staticRenderFns } from "./References.vue?vue&type=template&id=4cdfd1e0&lang=pug&"
import script from "./References.vue?vue&type=script&lang=ts&"
export * from "./References.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "References.vue"
export default component.exports